
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sarwa-capital",
      function () {
        return require("private-next-pages/sarwa-capital/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sarwa-capital"])
      });
    }
  